import {isDev} from 'utils/constants';

export const LANGUAGES = [
  {value: 'EN', label: 'English'},
  {value: 'FR', label: 'French'},
];

export const STEP_TEMPLATES = [
  {value: 'SIMPLE', label: 'Simple (FAQs → describe → AI)'},
  {value: 'CONTEXT_SELECT', label: 'Context Select (fetch user data first)'},
  {value: 'DIRECT', label: 'Direct (skip FAQs)'},
];

export const CONTEXT_ENTITY_TYPES = [
  'DEPOSIT',
  'WITHDRAWAL',
  'FUNDS',
  'BONDS',
  'STOCKS',
  'ORDERS',
  'DIVIDENDS',
  'VENTURE',
  'VENTURE_FUNDS',
  'IPOS',
  'COLLECTIONS',
  'WATCHLIST',
  'PORTFOLIO',
  'RECURRING_INVESTMENT',
  'TRADE',
  'DABA_PRO',
  'NOTIFICATIONS',
  'STATEMENTS_DOCUMENTS',
  'USER',
  'KYC',
  'SUBSCRIPTION',
  'RISK_PROFILE',
  'USER_SEGMENT',
];

/** Display labels for the ContextStepType enum. Catalog still drives which are allowed per step. */
export const CONTEXT_STEP_TYPE_LABEL = {
  LIST: 'List (multiple items)',
  DETAIL: 'Detail (single item)',
};

export const ICON_BUCKET = isDev
  ? 'sassandra-artifacts-dev'
  : 'sassandra-artifacts';
export const ICON_FOLDER = 'flowtree';

export const CLOSED_FORM_MODAL = {open: false, mode: 'create', record: null};
